export default __webpack_public_path__ + "static/media/Frame 7.313e064b.svg";